<template>
  <!-- <page :title="i18n.title"> -->
  <div class="home">
    <div class="downloadAppBox" v-if="downloadApp">
      <div class="downloadAppBox-cancel">
        <span @click="downloadApp = false">X</span>
        <span style="width: 20%">
          <img src="../../assets/imgs/img_logo.png" alt="" />
        </span>
        <!-- <span style="margin-left: 20px">
          <div>Blitz</div>
        </span> -->
      </div>
      <div class="downloadAppBox-btn btn" @click="onDownload">open</div>
    </div>
    <div class="google-map">
      <google-map
        ref="googlemap"
        :locationList="list"
        :latLng="latLng"
        @center="onCenter"
        @zoom="onZoom"
        @setItem="onSetItem"
        @onmap="show = false"
      />
      <div class="home-top" v-if="!isMap">

        <!-- <van-image
          :src="require('@/assets/imgs/icon_drawer.png')"
          width="1.12rem"
          @click="isMenuView = true"
        ></van-image> -->

        <!-- <img class="home-logo" src="@/assets/imgs/icon_logo.png"  /> -->

        <!-- <van-image
          :src="require('@/assets/imgs/icon_locate@2x.png')"
          width="1.12rem"
          @click="onLocation"
        ></van-image> -->
      </div>
      <!-- <div class="home-message">
      <div class="home-m-box">
        <van-image :src="require('assets/imgs/powerIn.png')" width="1.3rem"></van-image>
        <div class="m-box-title">You have orders in progress.</div>
        <div class="m-box-method">
          <span style="margin-right: 5px;">Method of return</span>
          <van-icon name="arrow"></van-icon>
        </div>
      </div>
    </div> -->
      <div class="home-bottom" v-if="!isMap">
        <div class="scan-box" @click="scanQr">
          <img :src="require('@/assets/imgs/icon_scan.png')" alt="">
        </div>
        <div class="home-scan">
          <div class="flex-e">
            <div class="nav-btn" @click="isMenuView = true">
              <van-image
                width="0.8rem"
                :src="require('@/assets/imgs/icon_drawer.png')"
              ></van-image>
              <p class="nav-label">{{ i18n.mine }}</p>
            </div>
            <div class="nav-btn" @click="onLocation">
              <van-image
                width="0.8rem"
                :src="require('@/assets/imgs/icon_locate@2x.png')"
              ></van-image>
              <p class="nav-label">{{ i18n.locate }}</p>
            </div>
          </div>
          <div class="nearbyshop" @click="goRouter('/shop' + shopQuery)">
            <div>{{ i18n.title }}</div>
            <img src="@/assets/imgs/icon_search@2x.png" />
          </div>
        </div>
        <!-- <div class="nearbyshop" @click="goRouter('/shop' + shopQuery)">
          <van-image
              width=".8rem" height=".8rem"
              :src="require('@/assets/imgs/nearbyshop.png')"
            ></van-image>
            <p class="nav-label">{{ i18nHome.nearbyvenues }}</p>
        </div> -->
      </div>
      <transition name="fade">
        <NearbyShop
          v-if="item && show"
          :item="item"
          @click="onClick"
        ></NearbyShop>
      </transition>
    </div>
    <popup-warp
      v-model="isMenuView"
      dialogTransition="slide-left"
      style="background: #fff; height: 100vh"
    >
      <menu-side></menu-side>
    </popup-warp>
    <popup-warp
      v-model="ishomeSearch"
      position="bottom"
      class="search"
      style="border-radius: 60px 60px 0px 0px"
    >
      <div class="pop-box">
        <searchPlus v-model="searchText" @handleValue="reload"></searchPlus>
      </div>
    </popup-warp>
    <div class="fixed" v-if="isPickUpShow" @click="isPickUpShow = false">
      <ScanQr @scanQr="onScanQr" />
    </div>
  </div>
  <!-- </page> -->
</template>

<script>
import { mapState } from "vuex"
import GoogleMap from "@/views/map/google-map.vue"
import ScanQr from "@/views/scanQr/scanQr.vue"
import { debounce } from "../../utils/index"
import { SHOP_LIST, QR_CODE } from "../../apis/cabinet"
import { TRANSBANK_CONFIRM } from "../../apis/payment"
import { PopupWarp } from "@/components/popup"
import { MenuSide } from "@/components/menu"
import searchPlus from "@/components/searchPlus/searchPlus.vue"
import NearbyShop from "./nearbyShop.vue"
export default {
  components: {
    GoogleMap,
    PopupWarp,
    searchPlus,
    MenuSide,
    ScanQr,
    NearbyShop
  },
  data() {
    return {
      latLng: [39.709857241147915, -102.41158521356913],
      zoomLevel: "4",
      list: [],
      item: null,
      show: false,
      isMenuView: false,
      ishomeSearch: false,
      isPickUpShow: false,
      searchText: "",
      isMap: false,
      downloadApp: false,
      allowedMaps: false
    }
  },
  computed: {
    ...mapState(["user", "token", "browser", "qrcode", "system", "transOrderNo"]),
    i18n() {
      return this.$t("map")
    },
    i18nHome() {
      return this.$t("home")
    },
    i18nMsg() {
      return this.$t("msg")
    },
    shopQuery() {
      const latLng = this.latLng || []
      return `?lat=${latLng[0]}&lng=${latLng[1]}`
    }
  },
  watch: {
    latLng() {
      this.lazyLoad(this)
    }
  },
  methods: {
    // type回调 shop_close 关闭弹框 shop_scan 扫码
    onClick(type) {
      if (type === "shop_close") {
        this.show = false
      } else if (type === "shop_scan") {
        this.show = false
        this.scanQr()
      } else {
        console.log("未开放")
        this.$toast(this.i18nMsg.notopen)
      }
    },
    goRouter(path) {
      this.$router.push(path)
    },
    reload(val) {
      console.log("reload===", val)
    },
    scanQr() {
      if (this.user && this.token) {
        this.isPickUpShow = true
      } else {
        this.$router.push("/login")
      }
    },
    onScanQr(qr) {
      console.log("qr====", qr)
      this.isPickUpShow = false
      let arr = qr.split("=")
      this.onScan(arr[1])
    },
    onScan(qrcode) {
      this.$loading(true)
      this.$post(
        `${QR_CODE}?id=${qrcode}&usePriceUnit=true`,
        {},
        (resp) => {
          this.$loading(false)
          this.$store.commit("cabinet", {
            qrcode: this.code,
            ...resp
          })
          if (resp.zujieNum && resp.zujieNum > 0 && !resp.haveMifiBattery) {
            this.$confirm({
              title: this.i18nHome.msg_fail_title,
              content: `${this.i18nHome.msg_rentcount}`.format(resp),
              confirmText: this.i18nMsg.vieworder,
              cancelText: this.i18nMsg.cancel
            })
              .then(() => {
                this.$router.push("/order")
                this.$store.commit("qrcode", "")
              })
              .catch(() => {
                this.$store.commit("qrcode", "")
              })
          } else {
            this.$router.push("/home?cabinetshow=true")
            this.allowedMaps = true
            // this.isScan = true
            // this.isBtns = false
            // this.adVisible = true
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    getNearbyShop() {
      this.$loading(true)
      let formdata = new FormData()
      formdata.append("coordType", "WGS－84")
      formdata.append("mapType", "WGS－84")
      formdata.append("lat", this.latLng[0])
      formdata.append("lng", this.latLng[1])
      formdata.append("zoomLevel", this.zoomLevel)
      formdata.append("showPrice", true)
      formdata.append("usePriceUnit", true)
      this.$post(
        SHOP_LIST,
        formdata,
        (resp) => {
          this.$loading(false)
          this.list = resp.list
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        },
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      )
    },
    onZoom(zoomLevel) {
      // console.log('zoom', zoomLevel)
      this.zoomLevel = zoomLevel
      this.lazyLoad(this)
    },
    lazyLoad: debounce((vm) => {
      vm.getNearbyShop()
    }, 500),
    onCenter(latLng) {
      this.latLng = latLng
      this.lazyLoad(this)
    },
    onSetItem(val) {
      this.item = val
      this.show = true
    },
    onDownload() {
      if (this.system === "ios") {
        window.open(process.env.VUE_APP_APP_STORE)
      } else {
        window.open(process.env.VUE_APP_GOOGLE_PLAY)
      }
    },
    // 加载扫码状态
    loadScanState() {
      const { qrcode } = this.$route.query
      const scanCode = sessionStorage.getItem("cdb_qrcode")
      if (!this.user && qrcode && scanCode !== qrcode) {
        sessionStorage.setItem("cdb_qrcode", qrcode)
      } else if (this.user && !qrcode && scanCode) {
        sessionStorage.removeItem("cdb_qrcode")
        this.onScan(scanCode)
      }
    },
    onLocation () {
      this.$refs.googlemap.onLocation()
    },
    onConfirmOrder() {
      this.$loading(true)
      let url = TRANSBANK_CONFIRM
      this.$get(
        url,
        {
          outTradeNo: this.transOrderNo
        },
        (resp) => {
          this.$loading(false)
          this.$store.commit("transOrderNo", "")
          if (resp.code === 0 && resp.data && resp.data.type === 'PreAuth') {
            this.$router.replace(
              `/result?tradeNo=${resp.data.orderId}&payMode=Transbank&payType=YJ`
            )
          } else {
            this.$router.replace({ path: `/order` })
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        }
      )
    }
  },
  created() {
    if (this.$route.query.isMap) {
      this.isMap = this.$route.query.isMap
    }
    if (this.$route.query.qrcode) {
      this.onScan(this.$route.query.qrcode)
    }
    let latitude = this.$route.query.latitude
    let longitude = this.$route.query.longitude
    if (latitude && longitude) {
      this.latLng = [+latitude, +longitude]
    }
    let transbankToken = new URLSearchParams(window.location.search).get('token_ws')
    console.log(transbankToken)
    if (transbankToken) {
      this.onConfirmOrder()
    }
  },
  mounted() {
    const { isScan } = this.$route.query
    this.loadScanState()
    // this.getNearbyShop()
    if (isScan) {
      this.scanQr()
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  /deep/.popup-warp {
    border-radius: 60px 60px 0px 0px;
  }

  .pop-box {
    // width: 100%;
    height: 1061px;
    background: #f5f5f5;
    box-shadow: 0px -10px 20px 1px rgba(0, 0, 0, 0.1);
    border-radius: 60px 60px 0px 0px;
    padding: 50px 40px;
  }
}

.fixed {
  position: fixed;
  bottom: 0;
  width: 100%;
  // background: rgba(45, 45, 45, 0.5);
  height: 100%;
}

.home {
  position: relative;
  display: flex;

  .home-top {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2;
    // background: linear-gradient( 180deg, rgba(57, 255, 20, 0.5) 0%, rgba(35,35,35,0) 100%);
    display: flex;
    padding: 70px 32px 35px;
    justify-content: center;
    align-items: center;
    .home-logo {
      width: 240px;
    }
  }

  .home-left {
    position: fixed;
    top: 96px;
    left: 40px;
    z-index: 2;
  }

  .home-right {
    position: fixed;
    top: 96px;
    right: 40px;
    z-index: 2;
  }

  .home-center {
    position: fixed;
    top: 120px;
    left: 0;
    right: 0;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .van-image /deep/ .van-image__img {
    width: 100%;
  }

  .home-message {
    width: 100%;

    position: fixed;
    top: 250px;
    margin: 0 auto;
    z-index: 1;

    .home-m-box {
      width: 90%;
      margin: 0 auto;
      height: 113px;
      background: #b2e6c7;
      border-radius: 18px 18px 18px 18px;
      display: flex;
      justify-content: flex-start;
      position: relative;

      .m-box-title {
        font-size: 28px;
        font-family: Work Sans-Medium, Work Sans;
        color: #00ab46;
        line-height: 2;
      }

      .m-box-method {
        position: absolute;
        bottom: 10px;
        right: 10px;
      }
    }
  }

  .home-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    // display: flex;
    // flex-flow: column;
    // align-items: center;
    // justify-content: center;
    .shop {
      float: right;
      margin-right: 40px;
      margin-top: -200px;
    }

    .home-scan {
      height: 254px;
      padding: 0 32px;
      margin: 30px 44px;
      // align-self: stretch;
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      background: rgba(255, 255, 255, 0.35);
      border-radius: 40px;

      .nav-btn {
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        // background: #000;
        padding: 18px 80px 10px 0;
        .nav-label {
          font-size: 28px;
          font-family: Work Sans-Bold, Work Sans;
          font-weight: bold;
          color: #fff;
          text-align: center;
          margin: 0;
        }
      }
    }
    .nearbyshop {
      height: 110px;
      padding: 0 74px 0 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #000;
      border-radius: 55px;
      bottom: 100%;
      color: #fff;
      img {
        width: 56px;
      }
    }
    .scan-box {
      position: absolute;
      left: 79px;
      bottom: 174px;
      padding: 44px 68px;
      border-radius: 50px;
      background-color: #52F6FB;
      img {
        width: 88px;
        height: 88px;
        display: block;
        margin: 0;
      }
    }
  }

  .shop {
    justify-content: end;
  }
}

.google-map {
  width: 100%;
  height: 100%;
  position: fixed;
  bottom: 0;
  overflow: hidden;
}

.fade-enter-active,
.fade-leave-active {
  transition: height 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  height: 0;
}

.detailfade-enter-active,
.detailfade-leave-active {
  transition: opacity 0.5s;
}

.detailfade-enter,
.detailfade-leave-to .fade-leave-active {
  opacity: 0;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  overflow: hidden;

  .shop-content {
    height: 600px;
    width: 100%;
    position: absolute;
    z-index: 100;
    bottom: 0;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    box-shadow: 0 -5px 10px #9e9b9b;
    background: #fff;

    .shop-title {
      display: flex;
      flex-direction: column;
      padding: 20px;
      background: #fff;
      border-radius: 20px;

      .title-info {
        padding: 0 30px;

        p {
          margin: 0 0 10px 0;
        }

        .return-num {
          margin-left: 20px;
          padding: 5px 10px;
          border: 1px solid #23aaf2;
          border-radius: 10px;
          color: #23aaf2;
        }

        .free-num {
          padding: 5px 10px;
          border: 1px solid #8dd35f;
          border-radius: 10px;
          color: #8dd35f;
        }

        .shop-time {
          h4 {
            margin: 20px 0;
            padding: 10px 0;
            border-bottom: 1px solid #cacdd1;
          }
        }
      }

      .shop-title-head {
        display: flex;
        flex-direction: row;
        align-items: center;

        h2 {
          margin: 10px 30px;
          padding: 20px 0;
          border-bottom: 1px solid #cacdd1;
        }

        .shop-tag {
          margin-left: 20px;
          font-size: 24px;
          padding: 5px 15px;
          border: 1px solid #cacdd1;
          border-radius: 10px;
        }

        .shop-tag-active {
          color: #8dd35f;
          border: 1px solid #8dd35f;
        }
      }
    }

    .address-detail {
      p {
        margin: 0;
        text-align: left;
        padding: 0 30px;
      }
    }
  }
}
</style>
